module.exports = __webpack_public_path__ + "static/img/85-3.f2b97e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/85-3.jpg
// module id = uzX0
// module chunks = 0